import { render, staticRenderFns } from "./PrivatePolicy.vue?vue&type=template&id=14d52993&scoped=true&"
import script from "./PrivatePolicy.vue?vue&type=script&lang=js&"
export * from "./PrivatePolicy.vue?vue&type=script&lang=js&"
import style0 from "./PrivatePolicy.vue?vue&type=style&index=0&id=14d52993&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d52993",
  null
  
)

export default component.exports